import { useEffect, useMemo, useState } from 'react';
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const Layout = (props) => {
  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(320);

  const fileUrlFinal = useMemo(() => props.fileUrl, [props.fileUrl]);

  useEffect(() => {
    const updateWidth = () => {
      const width = window.innerWidth;
      if (width < 640) {
        setPageWidth(Math.min(width - 56, 320));
      } else if (width < 768) {
        setPageWidth(Math.min(width - 72, 500));
      } else if (width < 1024) {
        setPageWidth(650);
      } else {
        setPageWidth(900);
      }
    };
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return {
    fileUrlFinal,
    numPages,
    pageWidth,
    onDocumentLoadSuccess
  }
};

export default Layout;
